const FETCH_ES_SEARCH_ALL = 'search/FETCH_ES_SEARCH_ALL';

const FETCH_ES_SEARCH_STORIES = 'search/FETCH_ES_SEARCH_STORIES';

const FETCH_ES_SEARCH_TAGS = 'search/FETCH_ES_SEARCH_TAGS';

const FETCH_ES_SEARCH_USERS = 'search/FETCH_ES_SEARCH_USERS';

const SET_SEARCHED_QUERY = 'search/SET_SEARCHED_QUERY';

const FETCH_POPULAR_TAGS = 'search/FETCH_POPULAR_TAGS';

const FETCH_TAG_RANKING = 'search/FETCH_TAG_RANKING';

const FETCH_RECOMMENDATIONS_V2 = 'search/FETCH_RECOMMENDATIONS_V2';

const RESET_ALL = 'search/RESET_ALL';

const RESET_RECOMMENDATIONS = 'search/RESET_RECOMMENDATIONS';

const SAVE_WATCH_LATER = 'search/SAVE_WATCH_LATER';

const DELETE_WATCH_LATER = 'search/DELETE_WATCH_LATER';

export default {
  FETCH_ES_SEARCH_ALL,
  FETCH_ES_SEARCH_STORIES,
  FETCH_ES_SEARCH_TAGS,
  FETCH_ES_SEARCH_USERS,
  SET_SEARCHED_QUERY,
  FETCH_POPULAR_TAGS,
  FETCH_TAG_RANKING,
  FETCH_RECOMMENDATIONS_V2,
  RESET_ALL,
  RESET_RECOMMENDATIONS,
  SAVE_WATCH_LATER,
  DELETE_WATCH_LATER,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/search/types.js